const resolution = {width: 1920, height: 1080};
const packFolder = "desktop_horizontal/";
const pathFolder = "desktop_horizontal/";

export const configGame_desktop_horizontal = {
    packFolder: packFolder,
    pathFolder: pathFolder,
    type: "DesktopHorizontal",

    Screen: {
        resolution: resolution,
        screen_ratio: resolution.width / resolution.height,
        loadscreen: {
            image: {name: "res/" + pathFolder + "loadscreen.jpg", rus: true},
            loadbar:{
                position: {x:668, y:902},
                image: "res/" + pathFolder + "loadbar.png"
            }
        }
    },

    MainScene: {
        frameUi: {pos: {x: 469, y: 584}},
        logoFix: {pos: {x: 713, y: 16}},
        logoX2: {pos: {x: 761, y: 31}},
        coin: {pos: {x: 807, y: 274}},
        animCoinOrel: {
            from: 39,
            frames: 78,
        },
        animCoinReshka: {
            from: 0,
            frames: 39,
        },
    },

    UiScene: {
        buttonSelectOrel: {pos: {x: 544, y: 571}},
        buttonSelectReshka: {pos: {x: 1074, y: 571}},
        buttonGameMode: {pos: {x: 149, y: 849}},
        buttonMore: {pos: {x: 1175, y: 965}},
        buttonStop: {pos: {x: 512, y: 965}},
        frameTotalBet: {
            visible: true,
            pos: {x: 447, y: 342},
            labelTotalBet: {
                pos: {x: 163, y: 103},
                font: {
                    name: "font_white_nums_desktop_horizontal",
                    tint: 0x00ff66
                }
            },
            labelTotalBetBefore: {
                pos: {x: 0, y: 0},
                font: {
                    name: "arial_regular_16_desktop_horizontal",
                }
            },
            labelTotalBetAfter: {
                pos: {x: 0, y: 0},
                font: {
                    name: "arial_regular_20_desktop_horizontal",
                }
            },
            chooseOrel: {pos: {x: 82, y: 35}},
            chooseReshka: {pos: {x: 94, y: 36}},
        },
        labelResult: {
            pos: {x: 970, y: 245},
            font: {
                name: "arial_bold_32_desktop_horizontal",
            }
        },
        labelCoeff: {
            pos: {x: 955, y: 670},
            font: {
                name: "font_coeff_desktop_horizontal",
            }
        },
        imgSelectLightOrel: {pos: {x: 544, y: 571}},
        imgSelectLightReshka: {pos: {x: 1074, y: 571}},
        animSelectLightOrel: {pos: {x: 550, y: 578}},
        animSelectLightReshka: {pos: {x: 1180, y: 578}},
    },

    UiSceneList: {
        maxListSize: 6,
        startY: 460,
        offY: 30,
        layer: {pos: {x: 1135, y: 0}},
        label: {
            pos: {x: 150, y: 0},
            font: {
                name: "font_list_nums_desktop_horizontal",
                align: "left",
                anchor: {x: 0.5, y: 0.5}
            }
        },
        labelCurrency: {
            pos: {x: 250, y: 17},
            font: {
                name: "arial_regular_16_currency_desktop_horizontal",
                align: "left",
                anchor: {x: 0.0, y: 0.5}
            }
        },
    },

    Settings: {
        background: {pos: {x: 334, y: 127}},
        backgroundTitle: {pos: {x: 481, y: 50}},
        countImg: 6,
        grid: {
            startPos: {x: 340, y: 210},
            stepLength: {x: 280, y: 170},
            scale: {x: 0.14, y: 0.14},
        },
        buttonOk: {pos: {x: 492, y: 650}},
    },

    AccountChangedWindow: {
        background: {pos: {x: 334, y: 127}},
        buttonOk: {pos: {x: 492, y: 581}},
        labelTitle: {
            font: {
                fontFamily: "Arial",
                fontSize: 40,
                fill: 0xffffff,
                align: "centre"
            }
        }
    },

    Help: {
        background: {pos: {x: 334, y: 127}},
        backgroundTitle: {pos: {x: 513, y: 62}},
        buttonOk: {pos: {x: 492, y: 581}},
        labelTitle: {
            pos: {x: 630, y: 120},
            font: {
                fontFamily: "Arial",
                fontSize: 40,
                fill: 0xffffff,
                align: "centre"
            }
        },
        labelTitle0: {
            pos: {x: 225, y: 230},
            font: {
                fontFamily: "Arial",
                fontSize: 36,
                fill: 0xffffff,
                align: "left"
            }
        },
        labelInfo: {
            pos: {x: 255, y: 235},
            font: {
                fontFamily: "Arial",
                fontSize: 24,
                fill: 0xffffff,
                align: "left"
            }
        },
        labelTitle1: {
            pos: {x: 225, y: 410},
            font: {
                fontFamily: "Arial",
                fontSize: 36,
                fill: 0xffffff,
                align: "left"
            }
        },
        labelInfo1: {
            pos: {x: 255, y: 415},
            font: {
                fontFamily: "Arial",
                fontSize: 24,
                fill: 0xffffff,
                align: "left"
            }
        },
        translateList: {
            name: {
                rus: 'Игра «Орел или Решка»',
                eng: 'Game «Flip the coin»'
            },
            mode: {
                rus: 'Фиксированная ставка',
                eng: '            Fix bet'
            },
            info: {
                rus: '    Определяетесь с размером ставки и бросаете монетку.\n' +
                '    Угадали? Поздравляем! Ваша ставка увеличивается в 2 раза!\n',
                eng: '    Choose either head or tail and select the value of your bet.\n' +
                '    Then flip the coin. Did you guess right? If yes, your bet is doubled!\n'
            },
            mode1: {
                rus: 'Удвоение ставки',
                eng: '            Doubling bet'
            },
            info1: {
                rus: '    Вы выбираете Орла или Решку и делаете ставку 50 RUB.\n' +
                '    Угадали? Можете забрать выигрыш 100 RUB или бросить еще раз...\n',
                eng: '    Choose .\n'
            },
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/desktop_horizontal/game.es6
// module id = 36
// module chunks = 0